import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4rem;
`

export const Link = styled.div`
  width: 100%;
  max-width: 26rem;

  .safari-lower-than-15 & {
    margin-top: 2.2rem;
  }

  @media screen and (min-width: 768px) {
    max-width: 32rem;
  }
`
